import type { ComponentType, SVGProps } from 'react'
import type { IconName } from './iconNames.generated'

export type { IconName } from './iconNames.generated'
export { iconNamesList } from './iconNames.generated'

export type SvgComponent = ComponentType<SVGProps<SVGSVGElement>>

// =============================================================================
// Runtime registry
// =============================================================================
// Vite's `import.meta.glob` with `eager: true` synchronously inlines every
// matching module at build time and tree-shakes nothing — a registry like
// this is exactly the right use case. The keys come back as the matched file
// paths, which we strip down to the basename (e.g. `Bell.tsx`), then convert
// to kebab-case (`bell`) so they line up with the auto-generated `IconName`
// union in `iconNames.generated.ts`.
//
// The build-time codegen (scripts/generate-icon-names.mjs) and this runtime
// loader use the EXACT same conversion algorithm — keep them in sync.
// =============================================================================

const modules = import.meta.glob<{ default: SvgComponent }>(
  './Components/*.tsx',
  { eager: true },
)

function toKebab(name: string): string {
  return name
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/([A-Z])([A-Z][a-z])/g, '$1-$2')
    .replace(/([a-zA-Z])(\d)/g, '$1-$2')
    .replace(/_/g, '-')
    .replace(/-+/g, '-')
    .toLowerCase()
}

const registry: Record<string, SvgComponent> = {}
for (const [filePath, mod] of Object.entries(modules)) {
  const fileName = filePath.split('/').pop()
  if (!fileName) continue
  const baseName = fileName.replace(/\.tsx$/, '')
  const iconName = toKebab(baseName)
  registry[iconName] = mod.default
}

export const iconRegistry = registry as Record<IconName, SvgComponent>
